<template>
	<ul class="steps">
		<li v-for="item in steps" :key="item" :class="item <= step ? 'active' :''">
			{{step === item ? '校准中' : (item > step ? '待校准' : '已完成')}}
		</li>
	</ul>
</template>
<script>
export default {
    name: 'steps',
    props: {
        steps: {
            type: Number,
            default: 3
        },
        step: {
            type: [String, Number],
            default: 1,
        }
    }
}
</script>
<style lang="less">
.steps {
	position: relative;
	counter-reset: step;
	display: flex;
	align-items: center;
}
/* 步骤描述 */
.steps li {
	list-style-type: none;
	font-size: 28px;
	text-align: center;
	position: relative;
	float: left;
	color: #bbbfc4;
	flex: 1;
}
/* 步骤数字 */
.steps li:before {
	display: block;
	content: counter(step); /* 设定计数器内容 */
	counter-increment: step; /* 计数器值递增 */
	height: 44px;
	width: 44px;
	border-radius: 28px;
	background-color: #dee0e3;
	color: #fff;
	font-weight: 500;
	margin: 0 auto 26px auto;
	position: inherit;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;
}
.steps .active {
	color: #1f2329;
}
.steps .active:before {
	box-shadow: 0 0 0 7px #d9f0f1;
}
/* 连接线 */
.steps li ~ li:after {
	content: '';
	width: 100%;
	height: 6px;
	background-color: #dee0e3;
	position: absolute;
	left: -48%;
	top: 19px;
	z-index: 0;
}
/* 将当前/完成步骤之前的数字及连接线变绿 */
.steps li.active:before,
.steps li.active:after {
	background-color: @primary;
}
</style>